<template>
  <c-base-dialog v-model="isShow" :option="popOption" @close="$emit('close')">
    <template slot="body">
      <div :class="['dialog', 'dialog--default', !isMobile ? 'dialog--pc' : '']">
        <div class="dialog-content">
          <div class="win-prize-body">
            <ul class="win-prize-body-title" :style="winPrizeRecordTitleBgStyle">
              <li class="win-prize-body-title-name" :style="prizeRecordItemCommonStyle">
                奖品
              </li>
              <li class="win-prize-body-title-time" :style="prizeRecordItemCommonStyle">
                时间
              </li>
              <li class="win-prize-body-title-action" :style="prizeRecordItemCommonStyle">
                操作
              </li>
            </ul>
            <template v-if="list.length > 0">
              <!--              // 滚动窗口-->
              <div class="win-prize-body-record-scroll-window">
                <ul class="win-prize-body-record"
                    :style="winPrizeRecordBottomBorderStyle"
                    v-for="(item, index) of list"
                    :key="index">
                  <li class="win-prize-body-record-name">
                    <span  :style="prizeRecordItemCommonStyle"
                           v-if="item.gift_name.length <= 8">{{ item.gift_name }}</span>
                    <span
                        :style="prizeRecordItemCommonStyle"
                        v-if="item.gift_name.length > 8"
                          class="text-decoration"
                          @click="showDetail(item.gift_name)">{{ item.gift_name.substring(0, 8) }}</span>
                  </li>
                  <li class="win-prize-body-record-time"
                      :style="prizeRecordItemTimeStyle">{{ item.show_gift_time }}</li>
                  <li class="win-prize-body-record-action">
                    <template v-if="checkIsSurvey(item.gift_id)">
                      <span class="text-decoration"
                            :style="prizeRecordItemCommonStyle"
                            @click="actionByType(item.gift_id, 'privateQualification')">填写问卷</span>
                    </template>
                    <template v-else-if="checkIsMatchGift(item.gift_id, 'packageRealGift')">
                      <span
                          :style="prizeRecordItemCommonStyle"
                          class="text-decoration" @click="$emit('fill-address')">填写地址</span>
                    </template>
                    <template v-else-if="checkIsMatchGift(item.gift_id, 'cash')">
                      <span class="text-decoration"
                            :style="prizeRecordItemCommonStyle"
                            @click="$emit('package:reward:record:event:wx-fill')">绑定微信</span>
                    </template>
                    <template v-else>
                      <span class="text-decoration" v-if="item.package_real_flag === '1'"
                            :style="prizeRecordItemCommonStyle"
                            @click="$emit('fill-address')">填写地址</span>
                      <span class="text-decoration" v-else-if="item.package_cdkey"
                            :style="prizeRecordItemCommonStyle"
                            @click="copyText(item.package_cdkey)">复制CDKEY</span>
                      <span v-else :style="prizeRecordItemCommonStyle">-</span>
                    </template>
                  </li>
                </ul>
              </div>

            </template>

            <template v-if="list.length  === 0">
              <div class="win-prize-body-empty-record-msg">
                还没获得奖品，快去参加活动吧
              </div>
            </template>
            <template v-if="list.length > 0">
              <div class="win-prize-body-page" v-if="Math.ceil(page.total / pageSize) > 1">
                <span @click="page.current > 1 && page.current--">上一页</span>
                <span class="win-prize-body-page-num">{{ page.current }}/{{ Math.ceil(page.total / pageSize) }}</span>
                <span @click="page.current < page.total / pageSize && page.current++">下一页</span>
              </div>
            </template>
          </div>
        </div>

      </div>
    </template>
  </c-base-dialog>
</template>

<script>
import { ClaimRecord } from '../apis';
import CDialog from '../base-dialog';
import common from '../../common';
import Vue from 'vue';

export default {
  name: 'package-claim-record',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    gameCode: String,
    params: Object,
    backgroundImage: String,
    hidePackageIds: Array,
    fontColor: {
      type: String,
      default: '#000',
    },
    option: Object,
    pageSize: Number,
  },
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      list: [],
      page: {
        current: 1,
        total: 0,
      },
      isShow: true,
      flowVersion3: 2,
      isMaterial: '1', // 实物状态码
    };
  },
  computed: {
    winPrizeRecordBottomBorderStyle() {
      return {
        borderBottom: `1px solid ${this.popStyleTextRgba.color10}`,
      };
    },
    winPrizeRecordTitleBgStyle() {
      return  { backgroundColor: this.popStyleTextRgba.color10 };
    },
    prizeRecordItemCommonStyle() {
      return {
        color: this.popStyleTextRgba.color100,
      };
    },
    prizeRecordItemTimeStyle() {
      return {
        color: this.popStyleTextRgba.color80,
      };
    },
    popStyleTextRgba() {
      const hexToRgba = (hex, opacity) => `rgba(${parseInt(`0x${hex.slice(1, 3)}`, 16)}
      ,${parseInt(`0x${hex.slice(3, 5)}`, 16)},${
  parseInt(`0x${hex.slice(5, 7)}`, 16)},${opacity})`;
      return {
        color100: this.popTextStyle.color,
        color50: hexToRgba(this.popTextStyle.color, 0.5),
        color80: hexToRgba(this.popTextStyle.color, 0.8),
        color10: hexToRgba(this.popTextStyle.color, 0.10),
      };
    },
    popTextStyle() {
      const { dialogStyle = {} } = this.option;
      let color = dialogStyle?.color;
      if (!color) {
        color = Vue.prototype?.$storeInstance?.getters?.dialogConfig?.dialogStyle?.color || '#000000';
      }
      return { color };
    },
    popOption() {
      // 用户配置
      console.log('---  user  setting  popConfig ---- ', this.option, this.backgroundImage);
      const { titleStyle = {}, dialogStyle: dialogStyleOption = {} } = this.option || {};
      // 新增标题颜色
      if (!titleStyle.color) {
        titleStyle.color = this.popTextStyle.color;
      }
      //  读取系统配置
      const { closeStyle = {}, dialogStyle = {} } = Vue.prototype?.$storeInstance?.getters?.dialogConfig ?? {};
      console.log('---  system  popConfig ---- dialogStyle', dialogStyle, closeStyle);
      let bgImageStyle = '';
      if (typeof this.backgroundImage === 'string' && this.backgroundImage) {
        bgImageStyle = `url(${this.backgroundImage})`;
      }
      const bgImageReg = /^url\((https:|http:)?\/\/[^\s]*\)$/;
      if (!bgImageStyle && dialogStyleOption.backgroundImage && bgImageReg.test(dialogStyleOption.backgroundImage)) {
        bgImageStyle = dialogStyleOption.backgroundImage;
      }
      if (!bgImageStyle && dialogStyle.backgroundImage && bgImageReg.test(dialogStyle.backgroundImage)) {
        bgImageStyle = dialogStyle.backgroundImage;
      }
      const popConfig = {
        header: '获奖记录',
        titleStyle: { fontSize: '0.40rem', borderBottom: 'none', fontWeight: 500, ...titleStyle },
        close: true,
        closeLocation: 'top-right',
        height: '7.2rem',
        width: '6.68rem',
        confirm: false,
        footer: false,
        dialogStyle: Object.assign(
          {},
          {
            color: this.popTextStyle.color,
            backgroundImage: bgImageStyle,
          },
        ),
      };
      //  如果有配置关闭按钮 设置不同位置  没有配置 默认走 top-right 的关闭样式
      if (closeStyle.backgroundImage && bgImageReg.test(closeStyle.backgroundImage)) {
        popConfig.closeStyle = { ...closeStyle, width: '0.3rem', height: '0.3rem', top: '0.4rem', right: '0.5rem' };
      }
      console.log('--------------------  final reward window popConfig  ------------= ', popConfig);
      return popConfig;
    },
  },
  watch: {
    'page.current'() {
      this.freshList();
    },
  },
  async mounted() {
    this.freshList();
  },
  methods: {
    getConfigFromActInfo(giftId, type) {
      const receiveGiftCustomConfig = Vue.prototype?.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      return receiveGiftCustomConfig
        ?.find(item => parseInt(item.gift_id, 10) === parseInt(giftId, 10) && item.type === type);
    },
    // 优先判断
    checkIsSurvey(giftId) {
      const id = parseInt(giftId, 10);
      if (!id) return false;
      const record = this.getConfigFromActInfo(giftId, 'privateQualification');
      if (record) {
        return true;
      }
      return false;
    },
    // 优先匹配个性化礼包类型
    checkIsMatchGift(giftId, type) {
      const id = parseInt(giftId, 10);
      if (!id) return false;
      const record = this.getConfigFromActInfo(giftId, type);
      if (record) {
        return true;
      }
      return false;
    },
    actionByType(giftId, type) {
      if (!type) {
        return;
      }
      const record = this.getConfigFromActInfo(giftId, type);
      if (!record) {
        return;
      }
      switch (type) {
        case 'privateQualification': {
          const { link = '' } = record?.playload ?? {};
          if (link) {
            window.location.href = link;
          }
        }
          break;
      }
    },
    async freshList() {
      if (this.$isInEditor) {
        this.list = new Array(this.pageSize).fill({
          gift_time: '2021-10-21 12:00:00',
          gift_name: '元宝x3',
          show_gift_name: '元宝x3',
          package_real_flag: '1',
        });
        this.page.total = 11;
        return;
      }
      const bushandang = Vue.prototype?.$actInfo?.extendConfig?.bushandang || false;
      if (this.params.flow_version === this.flowVersion3) {
        const response = await ClaimRecord.getClaimRecords({
          game_code: bushandang ? '' : this.gameCode,
          ...this.params,
          page_size: this.pageSize,
          page_index: this.page.current - 1,
        });
        this.page.total = response.data.total;
        const { list } = response.data;
        list.map((i, listIndex) => {
          const item = i;
          item.gift_time = item?.delivered_at > 0 ? this.timeTrans(item.delivered_at) : '';
          const giftNames = [];
          const giftPackageId = [];
          let packageRealFlag = '0';
          for (let k = 0; k < item.groups.length; k++) {
            // 是否存在排除礼包配置  并且当前礼包是否是排除礼包
            if (this.hidePackageIds && this.hidePackageIds.indexOf(item.groups[k].package_id) > 0) {
              continue;
            }
            if (parseInt(item.groups[k].amount, 10) > 0) {
              giftNames.push(`${item.groups[k].package_name} ${item.groups[k].amount}个`);
            } else {
              giftNames.push(item.groups[k].package_name);
            }
            giftPackageId.push(item.groups[k].package_id);
            if (item.groups[k].attached === this.isMaterial) {
              packageRealFlag = this.isMaterial;
            }
          }
          // 排除礼包后还存在数据 记录
          if (giftNames.length > 0) {
            item.gift_name = giftNames.join(',');
            item.package_real_flag = packageRealFlag;
            item.gift_id = giftPackageId.join(',');
            item.show_gift_name = giftNames.join(',');
            item.gift_name = item.show_gift_name;
            if (item.show_gift_name.length > 10) item.show_gift_name = item.show_gift_name.substr(0, 10);
            if (this.params.business_id === 'bb') {
              item.partition_name = common.tool.Base64.decode(item.partition_name);
            }
            this.list[listIndex] = item;
          }
          item.show_gift_time = this.timeShowFunc(parseInt(item.delivered_at, 10) * 1000);
          return item;
        });
      } else {
        ({ records: this.list, total: this.page.total } = await ClaimRecord.getClaimRecords({
          game_code: bushandang ? '' : this.gameCode,
          ...this.params,
          page_size: this.pageSize,
          page_index: this.page.current,
        }));
        if (this.hidePackageIds) {
          // this.list = this.list.filter(i => !~this.hidePackageIds.indexOf(i.gift_id));
          this.list = this.handleFilterWithHidePackageIds(this.list, this.hidePackageIds);
        }
        this.list = this.list.map((i) => {
          const item = i;
          // 处理gift_id
          const giftIds = item.gift_id.split(',');
          const giftNames = item.gift_name.split(',');
          const newGiftNames = [];
          for (let i = 0; i < giftIds.length; i++) {
            const giftItems = giftIds[i].split(':');
            if (giftItems.length === 2 && giftItems[1] > '1') {
              newGiftNames.push(`${giftNames[i]} ${giftItems[1]}个`);
            } else {
              newGiftNames.push(giftNames[i]);
            }
          }
          item.show_gift_name = newGiftNames.filter(i => !!i).join(',');
          // item.gift_name = newGiftNames.join(',');
          item.gift_name = item.show_gift_name;
          if (item.show_gift_name.length > 10) item.show_gift_name = item.show_gift_name.substr(0, 10);
          if (this.params.business_id === 'bb') {
            item.partition_name = common.tool.Base64.decode(item.partition_name);
          }
          item.show_gift_time = this.timeShowFunc(parseInt(item.created, 10) * 1000);
          return item;
        });
        console.log('-------------------- this.list = ', this.list);
      }
    },
    // 处理记录gift_id 返回多个 "xxx,xxx"
    // hidePackageIds 如果配置多个 "xxx,xxx"
    handleFilterWithHidePackageIds(list, hidePackageIds) {
      if (!list || list.length === 0) return [];
      // eslint-disable-next-line no-param-reassign
      list = list.map((item) => {
        let isHidden = false;
        let { gift_id: giftId, gift_name: giftName } = item;
        if (item.gift_id.indexOf(',') > -1) {
          let tempGiftIds = item.gift_id.split(',');
          const tempOriginGiftIdCount = tempGiftIds.length;
          const tempGiftName = item.gift_name.split(',');
          //  过滤要显示的
          tempGiftIds = tempGiftIds.filter((id, index) => {
            const res = hidePackageIds.indexOf(id) === -1;
            // 需要过滤不显示的礼包名称
            if (!res && typeof tempGiftName[index] !== 'undefined') {
              tempGiftName.splice(index, 1, '');
            }
            return res;
          });
          isHidden = tempGiftIds.length === 0;
          if (tempOriginGiftIdCount !== tempGiftIds.length) {
            giftId = tempGiftIds.join(',');
            giftName = tempGiftName.filter(i => !!i).join(',');
          }
        } else {
          isHidden = hidePackageIds.indexOf(item.gift_id) > -1;
        }
        return {
          ...item,
          isHidden,
          gift_id: giftId,
          gift_name: giftName,
        };
      });
      // eslint-disable-next-line no-param-reassign
      list = list.filter(i => i.isHidden === false);
      console.log('handleFilterWithHidePackageIds list=', list);
      return list;
    },
    showDetail(giftName) {
      this.alert(giftName);
    },
    copyText(content) {
      try {
        const isRTL = document.documentElement.getAttribute('dir') === 'rtl';

        const textarea = document.createElement('textarea');
        // Prevent zooming on iOS
        textarea.style.fontSize = '12pt';
        // Reset box model
        textarea.style.border = '0';
        textarea.style.padding = '0';
        textarea.style.margin = '0';
        // Move element out of screen horizontally
        textarea.style.position = 'absolute';
        textarea.style[isRTL ? 'right' : 'left'] = '-9999px';
        // Move element to the same position vertically
        const yPosition = window.pageYOffset || document.documentElement.scrollTop;
        textarea.style.top = `${yPosition}px`;

        textarea.setAttribute('readonly', '');

        // 赋值
        textarea.value = content;
        document.body.appendChild(textarea);
        // 选中
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        // 复制
        let succeeded;
        try {
          succeeded = document.execCommand('copy');
        } catch (err) {
          succeeded = false;
        }
        // 移除输入框
        document.body.removeChild(textarea);
        this.alert(`复制${succeeded ? '成功' : '失败'}`);
      } catch (e) {
      }
    },
    timeTrans(timeStr) {
      const date = new Date(timeStr * 1000); // 如果date为13位不需要乘1000
      const Y = `${date.getFullYear()}-`;
      const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
      const D = `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()} `;
      const h = `${date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()}:`;
      const m = `${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}:`;
      const s = (date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds());
      return Y + M + D + h + m + s;
    },
    // 毫秒时间戳
    timeShowFunc(time) {
      if (!time) {
        return '-';
      }
      const date = new Date(time);
      const Y = `${date.getFullYear()}-`;
      const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
      const D = `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()} `;
      const h = `${date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()}:`;
      const m = `${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}`;
      return `${Y}${M}${D} ${h}${m}`;
    },
  },
};
</script>

<style scoped>

.dialog--pc {
  font-size: 20px;
  width: 720px;
}

.dialog {
  font-size: 0.2rem;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 7.2rem;
  position: absolute;
}

.dialog-content {
  text-align: center;
  margin: 0 auto;
}

.dialog--default .win-prize-body {
  width: 5.6rem;
  margin-top: 0.3rem;
  height: 4.9rem;
  padding: 0 0.05rem;
}

.dialog--default .win-prize-body-title {
  width: 5.6rem;
  height: 0.56rem;
  line-height: 0.56rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  text-align: center;

}

.dialog--default .win-prize-body-title .win-prize-body-title-name {
  width: 2rem;
}

.dialog--default .win-prize-body-title .win-prize-body-title-time {
  width: 2rem;
}

.dialog--default .win-prize-body-title .win-prize-body-title-action {
  width: 1.6rem;
}

.dialog--default .win-prize-body-record .win-prize-body-record-name {
  width: 2rem;
}

.dialog--default .win-prize-body-record .win-prize-body-record-time {
  width: 2rem;
  font-size: 0.22rem;

}

.dialog--default .win-prize-body-record .win-prize-body-record-action {
  width: 1.6rem;
}

.win-prize-body-record .text-decoration {
  text-decoration: underline;
}


.dialog--default .win-prize-body-title li {
  font-size: 0.24rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
}

.win-prize-body-record-scroll-window {
  height: 4rem;
  max-height: 4rem;
  overflow-y: scroll;
}

.dialog--default .win-prize-body-record {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  justify-content: flex-start;
}

.dialog--default .win-prize-body-record li {
  width: 5.6rem;
  height: 0.65rem;
  line-height: 0.65rem;
  font-size: 0.24rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  text-align: center;
  list-style: none;

}

.dialog--default .win-prize-body-empty-record-msg {
  letter-spacing: 1px;
  font-size: 0.24rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  margin: 0 auto;
  margin-top: 40%;
}

.dialog--default .win-prize-body-page {
  font-size: 0.24rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  margin-top: 0.2rem;
}

.dialog--default .win-prize-body-page .win-prize-body-page-num {
  margin: 0 0.7rem;
}

.win-prize-body-record-name span {
  white-space:nowrap;
}

.win-prize-body-record-time {
  white-space:nowrap;
}


</style>
